export default {
  ORIGIN_TOKEN: "",
  API_URL: "https://api.crescolabs.com",
  API_KEY: "73jjmpnQVc8JNX0JRMYH85DFkGQVxIXNf1Gfm6Bj"
};
